<template>
  <div class="mt-1">
    <b-button
      variant="danger"
      size="sm"
      block
      :disabled="downloading || isDownloading"
      @click="triggerFileInput"
    >
      <template v-if="!downloading">
        <FeatherIcon icon="DownloadIcon" />
        Dosya İndir
      </template>
      <template v-else>
        <div class="d-flex align-items-center justify-content-between">
          <b-spinner
            variant="light"
            small
          />
          <span>%{{ downloadProgress.toFixed(0) }}</span>
        </div>
      </template>
    </b-button>
  </div>
</template>
<script>
import { BButton, BSpinner } from 'bootstrap-vue'

export default {
  name: 'DownloadFile',
  components: {
    BButton,
    BSpinner,
  },
  props: {
    fileId: {
      type: Number,
      required: true,
    },
    fileComponent: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      downloading: false,
      downloadProgress: 0,
      progressInterval: null,
    }
  },
  computed: {
    isDownloading() {
      return this.$store.getters['app/isDownloading']
    },
  },
  methods: {
    startProgressAnimation() {
      this.downloadProgress = 0
      this.progressInterval = setInterval(() => {
        if (this.downloadProgress < 90) {
          // Gerçekçi bir progress animasyonu için rastgele artış
          const increment = Math.random() * 15 + 5
          this.downloadProgress = Math.min(this.downloadProgress + increment, 90)
        }
      }, 200)
    },

    // İndirme tamamlandığında progress'i bitirme
    completeDownload() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval)
        this.progressInterval = null
        this.$store.commit('app/SET_DOWNLOADING', false)
      }

      // Progress'i 100%'e tamamla
      this.downloadProgress = 100

      // Kısa bir süre sonra progress bar'ı gizle
      setTimeout(() => {
        this.downloading = false
        this.downloadProgress = 0
      }, 500)
    },

    triggerFileInput() {
      if (this.fileId && this.fileComponent) {
        this.$store.commit('app/SET_DOWNLOADING', true)
        // yeni sekmede yönlendir
        this.downloading = true
        this.downloadProgress = 0
        this.startProgressAnimation()
        this.$store.dispatch('downloads/createDownload', {
          item_id: this.fileId,
          component: this.fileComponent,
        })
          .then(response => {
            if (response.status) {
              this.$store.dispatch('downloads/downloadFile', { token: response.token })
                .then(resp => {
                  if (resp) {
                    const respData = resp.data
                    if (respData.success) {
                      let blob

                      if (respData.chunks) {
                        // Chunk'ları birleştir
                        console.log('Chunk sayısı:', respData.total_chunks)

                        const byteArrays = []
                        respData.chunks.forEach(chunk => {
                          const byteCharacters = atob(chunk)
                          const byteNumbers = new Array(byteCharacters.length)

                          // eslint-disable-next-line no-plusplus
                          for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i)
                          }

                          byteArrays.push(new Uint8Array(byteNumbers))
                        })

                        // Tüm chunk'ları birleştir
                        const totalLength = byteArrays.reduce((acc, arr) => acc + arr.length, 0)
                        const result = new Uint8Array(totalLength)
                        let offset = 0

                        byteArrays.forEach(arr => {
                          result.set(arr, offset)
                          offset += arr.length
                        })

                        blob = new Blob([result], { type: respData.mime_type })
                      } else {
                        // Normal base64
                        const byteCharacters = atob(respData.content)
                        const byteNumbers = new Array(byteCharacters.length)

                        // eslint-disable-next-line no-plusplus
                        for (let i = 0; i < byteCharacters.length; i++) {
                          byteNumbers[i] = byteCharacters.charCodeAt(i)
                        }

                        const byteArray = new Uint8Array(byteNumbers)
                        blob = new Blob([byteArray], { type: respData.mime_type })
                      }
                      const url = window.URL.createObjectURL(blob)

                      const link = document.createElement('a')
                      link.href = url
                      link.download = respData.filename
                      link.click()

                      window.URL.revokeObjectURL(url)
                      this.completeDownload()
                    }
                  }
                })
                .catch(() => {
                  this.completeDownload()
                })
            } else {
              this.completeDownload()
            }
          })
          .catch(() => {
            this.completeDownload()
          })
      }
    },
  },
}
</script>
